import { useEffect, useState } from 'react';

// Make sure to align query with CSS media-queries; e.g. for
// media-breakpoint-up-md (768px) set query to '(max-width: 767px)'
const useMedia = query => {
  const getMatches = foundQuery => {
    // Prevents SSR issues
    if (typeof window !== 'undefined') {
      return window.matchMedia(foundQuery).matches;
    }
    return false;
  };

  const [matches, setMatches] = useState(getMatches(query));

  function handleChange() {
    setMatches(getMatches(query));
  }

  useEffect(() => {
    const matchMedia = window.matchMedia(query);

    // Triggered at the first client-side load and if query changes
    handleChange();

    // Listen matchMedia
    if (matchMedia.addListener) {
      matchMedia.addListener(handleChange);
    } else {
      matchMedia.addEventListener('change', handleChange);
    }

    return () => {
      if (matchMedia.removeListener) {
        matchMedia.removeListener(handleChange);
      } else {
        matchMedia.removeEventListener('change', handleChange);
      }
    };
  }, [query]);

  return matches;
};

export default useMedia;
